import React,{useState} from 'react';
import logo from "../Image/logo1.png";
import "../index.css";
// Now to How to submit this code 

export default function Contact(){

const [name, setName]=useState("");
const [email, setEmail]=useState("");
const [message,setMessage]=useState("");

function encode(data) {
  return Object.keys(data)
    .map(
      (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
    )
    .join("&");
}

function handleSubmit(e) {
  e.preventDefault();
  fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encode({ "form-name": "contact", name, email, message }),
  })
    .then(() => alert("Message sent!"))
    .catch((error) => alert(error));
}

  return (
    <>
    <section id="contact" className="relative">
      <div className="Contact">
        <img src={logo} alt="Contact"/>
      </div>
     
      <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
        <div className="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
          <iframe
            width="100%"
            height="100%"
            title="map"
            className="absolute inset-0"
            // frameBorder={0}
            // marginHeight={0}
            // marginWidth={0}
            style={{ filter: "opacity(0.7)" }}
           src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d29440.64832943497!2d75.871344!3d22.725229!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb884fc340de875c6!2sShri%20Govindram%20Seksaria%20Institute%20of%20Technology%20and%20Science!5e0!3m2!1sen!2sin!4v1671828259257!5m2!1sen!2sin"
          />
          <div className="bg-gray-900 relative flex flex-wrap py-7 rounded shadow-md max-h-fit max-w-fit" >
            
            <div className="lg:w-1/2 box-sizing:border-box px-6 mt-4 lg:mt-0">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs">
                EMAIL
              </h2>
              <a className="text-indigo-400 leading-relaxed">
                pggupta1317@gmail.com
              </a>
              <h2 className="title-font font-semibold text-white tracking-widest text-xs mt-4 ">
                PHONE
              </h2>
              <p className="leading-relaxed text-white font-light">9399810961</p>
            </div>
            <div className="lg:w-1/2 px-6">
              <h2 className="title-font font-semibold text-white tracking-widest text-xs ml-2">
                ADDRESS
              </h2>
              <p className="mt-1 text-white font-light ml-2">
                Sgsits college <br />
                Indore
              </p>
            </div>
          </div>
        </div>
        <form
          netlify
          name="contact"
          onSubmit={handleSubmit}
          className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
          <h2 className="text-blue-500 sm:text-4xl text-3xl mb-1 font-medium title-font">
            Hire Me
          </h2>
          <p className="leading-relaxed mb-5 text-gray-700">
            Choose a Right person for your Company role .
            Give me a chances to be a right person.
          </p>
          <div className="relative mb-4">
            <label htmlFor="name" className="leading-7 text-sm text-gray-400">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              className="w-full bg-gray-700 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-light-gray-600 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
              onChange={(e)=>setName(e.target.value)}
            />
          </div>
          <div className="relative mb-4">
            <label htmlFor="email" className="leading-7 text-sm text-gray-400">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="w-full bg-gray-700 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
            onChange={(e)=>setEmail(e.target.value)}
           />
          </div>
          <div className="relative mb-4">
            <label
              htmlFor="message"
              className="leading-7 text-sm text-gray-400">
              Message
            </label>
            <textarea
              id="message"
              name="message"
              className="w-full bg-gray-700 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
             onChange={(e)=>setMessage(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
            Submit
          </button>
        </form>
      </div>
    </section>
    </>
  )
}

